﻿/**
 * Rounds a number to a specified precision of digits after the comma
 * @param number: the number to round
 * @param precision: the number of precision digits to round to, after the comma
 */
export function round(number: number, precision: number) {
	const powerOfTen = Math.pow(10, precision);

	return Math.round(number * powerOfTen) / powerOfTen;
}
